﻿import { queries } from "@/graphql";
import { useQuery } from "@apollo/client/react";
import { enqueueSnackbar } from "notistack";
import type { PricesDetailType, QueryTaxesInvoiceArgs } from "@/types/graphql";

/**
 * Custom hook to create taxes invoices.
 * @param {object} variables - The variables to be passed to the mutation.
 * @param {Function} [onCompleted] - Callback function to be called when the mutation completes successfully.
 * @param {Function} [onError] - Callback function to be called when an error occurs during the mutation.
 * @returns {{createInvoice: Function, creating: boolean}} - The function to create the invoice and the loading state.
 */
export function useTaxesInvoices(
  variables: QueryTaxesInvoiceArgs,
  onCompleted: (data?: any) => void = () => {},
  onError: (error?: any) => void = () => {},
) {
  const { data, loading } = useQuery<
    {
      taxesInvoice: PricesDetailType | null;
    },
    QueryTaxesInvoiceArgs
  >(queries.taxesInvoices, {
    variables,
    // @ts-ignore
    // @ts-expect-error
    onCompleted: ({ climateData }) => {
      onCompleted(climateData);
    },
    onError: (err: Error) => {
      onError();

      enqueueSnackbar(err.message, {
        variant: "error",
      });
    },
    errorPolicy: "all",
  });

  return {
    data: data?.taxesInvoice || null,
    loading,
  };
}
